import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeSubscriptionModel } from './upgrade-subscription.model';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms';
//import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService, User, AnalyticsService } from '@icullen/api/shared';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

type UpgradeDescriptionFormModel = FormGroup<{
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  company: FormControl<string>;
  email: FormControl<string>;
  documentnumber: FormControl<string>;
  service: FormControl<string>;
}>;

@Component({
  selector: 'icullen-upgrade-subscription',
  templateUrl: './upgrade-subscription.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./upgrade-subscription.component.scss'],
})
export class UpgradeSubscriptionComponent implements OnInit {
  //user: UpgradeSubscriptionModel = new UpgradeSubscriptionModel();
  upgradeSubscriptionForm: UpgradeDescriptionFormModel;
  service: string;
  uniqueNumber: string;
  company: string;
  errorMessage = '';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private location: Location,
    private route: ActivatedRoute //, private http: HttpClient
  ) {}

  goBack() {
    this.location.back();
  }

  ngOnInit() {
    const user: User = this.authService.currentUser;
    this.service = this.route.snapshot.queryParamMap.get('service');
    this.uniqueNumber = this.route.snapshot.queryParamMap.get('uniqueNumber');
    this.company = this.route.snapshot.queryParamMap.get('company');
    this.analyticsService.pushUpgradeSubscriptionEvent(
      this.service,
      this.uniqueNumber,
      'viewContent'
    );
    this.upgradeSubscriptionForm = this.formBuilder.group({
      firstName: [user.given_name, [Validators.required]],
      lastName: [user.family_name, [Validators.required]],
      company: [this.company, [Validators.required]],
      email: [user.email, [Validators.required, Validators.email]],
      documentnumber: [this.uniqueNumber],
      service: [this.service],
    });
  }

  resetForm() {
    //this.upgradeSubscriptionForm.reset();
    this.upgradeSubscriptionForm.setValue({
      firstName: '',
      lastName: '',
      company: '',
      email: '',
      documentnumber: this.uniqueNumber,
      service: this.service,
    });
  }

  addAnalyticsData(event) {}

  onSubmit(e: any) {
    // alert(this.user.firstName + ' ' + this.user.lastName + ' ' + this.user.company + ' ' + this.user.email);
    if (this.upgradeSubscriptionForm.invalid) {
      //console.log('error in form :  check the fields');
      this.errorMessage = 'Mandatory fields are not filled.';
      return;
    } else {
      //console.log('Form submitted successfully');
      this.errorMessage = '';
      this.analyticsService.pushUpgradeSubscriptionEvent(
        this.service,
        this.uniqueNumber,
        'upgradeSubscriptionRequestSent'
      );
      e.target.submit();

      // let body = new URLSearchParams();
      // body.set('customer', 'ch000097152eArad');
      // body.set('rurl', 'https://pages.cullen-international.com/Thank-you-page-Trial-Request');
      // body.set('dialogid', '1159');
      // body.set('cke', '1');
      // body.set('firstName',this.user.firstName);
      // body.set('lastName',this.user.lastName);
      // body.set('email',this.user.email);
      // body.set('company',this.user.company);
      // console.log(body.toString());

      // const httpHeaders = new HttpHeaders({
      //   'Content-Type' : 'application/x-www-form-urlencoded',
      //   'Accept' : 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9'
      //   });

      // this.http.post('https://web.cullen-international.com/api/forms/submit', body.toString(),{
      //   headers: httpHeaders,
      //   observe: 'response',
      //   responseType: 'text'
      //   //responseType : 'html'
      // })
      // .subscribe(
      //   (response) => console.log(response),
      //   (error) => console.log(error)
      // )
    }
  }
}
